import { render, staticRenderFns } from "./quem_e_quem.vue?vue&type=template&id=60e430e7&scoped=true&"
import script from "./quem_e_quem.vue?vue&type=script&lang=js&"
export * from "./quem_e_quem.vue?vue&type=script&lang=js&"
import style0 from "./quem_e_quem.vue?vue&type=style&index=0&id=60e430e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e430e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60e430e7')) {
      api.createRecord('60e430e7', component.options)
    } else {
      api.reload('60e430e7', component.options)
    }
    module.hot.accept("./quem_e_quem.vue?vue&type=template&id=60e430e7&scoped=true&", function () {
      api.rerender('60e430e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/home/quem_e_quem.vue"
export default component.exports